import type { ReactElement } from "react";
import * as React from "react";

export default function XWithShadowIcon(props: React.SVGProps<any>): ReactElement {
  return (
    <svg width="1em" height="1em" viewBox="0 0 90 92" {...props}>
      <defs>
        <filter x="-105%" y="-105%" width="310%" height="310%" filterUnits="objectBoundingBox" id="XWithShadowFilter">
          <feOffset in="SourceAlpha" result="shadowOffsetOuter" />
          <feGaussianBlur stdDeviation={14} in="shadowOffsetOuter" result="shadowBlurOuter" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter" />
        </filter>
        <path
          d="M24.754 20L39.015 5.74A3.361 3.361 0 1034.262.985L20 15.246 5.738.985A3.361 3.361 0 10.984 5.738L15.246 20 .984 34.262a3.362 3.362 0 004.754 4.753L20 24.754l14.262 14.261a3.361 3.361 0 104.753-4.753L24.754 20z"
          id="XWithShadowPath"
        />
      </defs>
      <g transform="translate(25 26)" fillRule="nonzero" fill="none">
        <use fill="#000" filter="url(#XWithShadowFilter)" xlinkHref="#XWithShadowPath" />
        <use fill="#FFF" xlinkHref="#XWithShadowPath" />
      </g>
    </svg>
  );
}
